import React from 'react';

const showSubStringIfLongThan = (str, num) => `${str.substring(0, num)}${str.length > num ? '...' : ''}`;
const EditSeasonButton = ({ openAddEditContractDialog, seasonRatesIndex, seasonName, dateRanges, className, style, existingSeasons }) => {
  const openEditSeasonModal = () => openAddEditContractDialog({
    type: 'editSeason',
    data: {
      seasonIndex: seasonRatesIndex,
      title: 'Edit Season',
    },
  });
  return (
    <div
      className={className}
      style={{ cursor: 'pointer', color: '#f44336', ...style }}
      onClick={openEditSeasonModal}
    >
      Update Season Dates
    </div>
  );
};

export default EditSeasonButton;



// WEBPACK FOOTER //
// ./src/app/components/contracting/contract-activities-products/product/edit-season-button.jsx